import { takeEvery, put, call } from "redux-saga/effects";
import { defineMessages } from "react-intl";
import * as TaskActions from "../task/taskActions";
import { makeApiCall } from "../helpers";
import taskServices from "../../services/taskServices";
import { ALERT_TYPES, showAlert } from "../alert/alertActions";

import * as AdditionalActionActions from "./additionalActionActions";

const messages = defineMessages({
    fetchFailed: {
        id: "alerts.additional-actions-sagas.fetch-failed",
        defaultMessage: "Unable to retrieve additional actions: {responseError}",
        description: "Unable to retrieve additional actions alert message",
    },
    saveSucceeded: {
        id: "alerts.additional-action-sagas.save-succeeded",
        defaultMessage: "Additional action  status change succeeded",
        description: "Additional action  status change succeeded",
    },
    saveFailed: {
        id: "alerts.additional-action-sagas.save-failed",
        defaultMessage: "SAdditional action  status change  failed",
        description: "Additional action  status change  failed alert message",
    },
});

export const watchAdditionalActionRequests = function* () {
    yield takeEvery(AdditionalActionActions.REQUEST_ADDITIONAL_ACTION, fetchAdditionalAction);

    yield takeEvery(AdditionalActionActions.SAVE_ADDITIONAL_ACTION_INFO, saveAdditionalAction);
};

export const fetchAdditionalAction = function* (action) {
    try {
        let additionalActionStatus = yield call(makeApiCall, taskServices.getAdditionalAction) || [];
        yield put(AdditionalActionActions.requestAdditionalActionSucceeded(additionalActionStatus));
    } catch (responseError) {
        yield put(showAlert(Date.now(), messages.fetchFailed, ALERT_TYPES.error, { responseError: responseError.body }));
        yield put(AdditionalActionActions.requestAdditionalActionFailed());
    }
};

export const saveAdditionalAction = function* (action) {
    try {
        const additionalActionResponse = yield call(makeApiCall, taskServices.saveAdditionalAction, {
            actionCode: action.additionalActionRequest.toString(),
            workOrderNumber: action.workOrderNumber,
            username: action.username,
        });
        yield put(AdditionalActionActions.saveAdditionalActionSucceeded(additionalActionResponse));

        // refresh the updated task
        if (action.refresh) {
            yield put(TaskActions.fetchWorkorder(action.workOrderNumber, true));
        }
        yield put(showAlert(Date.now(), messages.saveSucceeded, ALERT_TYPES.success));
    } catch (responseError) {
        yield put(showAlert(Date.now(), messages.saveFailed, ALERT_TYPES.error, { responseError: responseError.body }));
        yield put(AdditionalActionActions.saveAdditionalActionFailed());
    }
};
